<template>
  <div class="h5Home">
    <router-view v-if="showTypa" />
  </div>
</template>

<script>
import { memberLogin } from "@/api/api.js";

export default {
  data() {
    return {
      showTypa: false
    };
  },
  mounted() {
    if (this.$route.query.openId) {
      this.memberLogin();
    } else {
      this.showTypa = true;
    }
  },
  methods: {
    memberLogin() {
      memberLogin(this.$route.query.openId).then(res => {
        if (res.code === 0) {
          const obj = {
            openId: res.data.openId,
            expirationDate: res.data.expirationDate,
            head: res.data.head,
            id: res.data.id,
            isExpire: res.data.isExpire,
            mobile: res.data.mobile,
            name: res.data.name
          };
          if (!obj.mobile) {
            this.$router.push({ name: "H5sign" });
          }
          window.sessionStorage.setItem("userList", JSON.stringify(obj));
          this.showTypa = true;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
    // societyOverview
  }
};
</script>

<style lang="less">
.h5Home {
  width: 100%;
}
</style>
